export const QUILL_MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],    // 글자 스타일
    [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 목록
    [{ 'align': [] }],                             // 정렬
    ['clean']                                      // 포맷 초기화
  ]
};